import { AB_SIMILAR_MATERIAL_LIST } from "@/constants/ABMng";
import { useABTestWithCache } from "@/utils/hooks/useABtest";
import { createContext, ReactNode, useContext } from "react";

interface PinDetailContextValue {
  relatedBoardsList?: any;
  boardMatchingResult?: any;
  isNewUser?: boolean;
  onUserBoardUpdate?: (board: any) => void;
  enableBoardRecommend?: boolean;
  flagValue?: {
    hbPinDetailFeedFlag: boolean;
    similarMaterialListFlag: string;
  };

  similarMaterialListAB?: {
    loading: boolean;
    value: string;
    horizontal_1: boolean;
    horizontal_2: boolean;
    old: boolean;
  };

  // 【推荐画板】横向滚动的当前页数
  boardSwiperCurrentPage?: number;
  // 【推荐画板】累积的所有画板数据
  allBoardsFromSwiper?: any[];
  // 更新【推荐画板】页数的回调（同时传递累积数据）
  onBoardSwiperPageChange?: (page: number, allBoards?: any[]) => void;
  // 获取下一个应该拉取的画板页码（用于 BoardSwiper 与瀑布流共享页码）
  getNextBoardPage?: () => number;
  // 全局画板页码 ref（BoardSwiper 和瀑布流共享）
  globalBoardPageRef?: React.MutableRefObject<number>;
  // 瀑布流独立加载的单画板卡片数据
  boardCardsFromWaterfall?: any[];
}

const PinDetailContext = createContext<PinDetailContextValue>({});

interface PinDetailProviderProps {
  children: ReactNode;
  value: PinDetailContextValue;
}

export function PinDetailProvider({ children, value }: PinDetailProviderProps) {
  const { flagValue } = value;

  // 相似素材ab实验
  const similarMaterialListAB = useABTestWithCache({
    ...AB_SIMILAR_MATERIAL_LIST,
    defaultValue:
      flagValue?.similarMaterialListFlag ||
      AB_SIMILAR_MATERIAL_LIST.defaultValue,
  });

  return (
    <PinDetailContext.Provider value={{ ...value, similarMaterialListAB }}>
      {children}
    </PinDetailContext.Provider>
  );
}

export function usePinDetailContext() {
  return useContext(PinDetailContext);
}
